// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  name: "UnimogProductSiegel",
  mixins: [template],
})
export default class UnimogProductSiegel extends Vue {
  @Prop()
  siegelNummer!: string;

  @Prop()
  provedBy!: string;
}
